/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @description
 * 자신/자신과 관계된 모든 사용자의 정보를 참조합니다.
 * 1. webapp 단에서는 값을 읽기만 합니다.
 * 2. 값의 수정은 반드시 제공된 API만 사용합니다. (외부에서 recoil 값 수정 금지)
 **/

import * as APIs from "./private";

export default function useNotice(events: API.Events = {}, options: API.Options = { initialStart: false }) {
	return {
		//*
		...APIs.withNotification(events, options)
		/*/
		...APIs.withNotificationV2(events, options)
		//*/
	};
}
